import HttpClient from "../services/HttpClient";
import {
  APP_URL,
  CVFINISH,
  CV,
  CVBYDOCUMENTANDTYPE,
  ERROR_MESSAGE,
} from "../constants";

export const finishCv = (cv, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${CVFINISH}`, cv, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const updateCv = (cv, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL}${CVFINISH}`, cv, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getCvById = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${CV}${id}`, headers)
      .then((response) => {
        if (response.data) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

//https://selection-dot-sae-dev.ue.r.appspot.com/curriculum/by-document-and-type/74376653/CC
export const getValidateCvByDocumentAndType = (document, type, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL}${CVBYDOCUMENTANDTYPE}?document=${document}&type=${type}`,

      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};
